import { computed, type ComputedRef, type MaybeRef, toValue } from 'vue';
import type { IconBreakpoint } from './button-types';

export function calculateBreakpoints(
  breakpoint?: MaybeRef<IconBreakpoint>,
): ComputedRef<{
  showAfterBreakpointClasses: string;
  hideAfterBreakpointClasses: string;
}> {
  return computed(() => {
    const unwrappedBreakpoint = toValue(breakpoint);

    if (unwrappedBreakpoint === 'always') {
      return {
        showAfterBreakpointClasses: 'hidden',
        hideAfterBreakpointClasses: 'block',
      };
    }

    if (!unwrappedBreakpoint) {
      return {
        showAfterBreakpointClasses: 'block',
        hideAfterBreakpointClasses: 'hidden',
      };
    }

    const showAfterBreakpointClasses = `hidden ${unwrappedBreakpoint}:block`;
    const hideAfterBreakpointClasses = `block ${unwrappedBreakpoint}:hidden`;
    return { showAfterBreakpointClasses, hideAfterBreakpointClasses };
  });
}
